import { t as m } from "./morphNodes-BUJqEfyn.js";
import { t as u } from "./cacheFetch-DVg5INtU.js";
var w = () => ({
  productSoldOut: !1,
  hasRequired: !0,
  controller: new AbortController(),
  checkRequired(t) {
    const e = new FormData(t);
    this.hasRequired = t.elements.toArray().filter((r) => r instanceof HTMLInputElement || r instanceof HTMLSelectElement || r instanceof HTMLTextAreaElement).filter((r) => r.required && r.name?.endsWith("[id]")).map((r) => e.get(r.name)).every((r) => r && r !== "null");
  },
  init() {
    const t = this.$el.querySelector("form[action='/cart/add']");
    t?.addEventListener("change", () => {
      this.checkRequired(t);
    }, { signal: this.controller.signal }), t && this.checkRequired(t);
  },
  destroy() {
    this.controller.abort();
  },
  async changeVariant(t) {
    console.log("Replacing page with:", t);
    const e = new URL(t, window.location.origin);
    window.history.replaceState({}, "", e);
    const r = await u(e);
    if (!r) {
      console.error("Failed to fetch the new variant page:", t);
      return;
    }
    const a = this.$el.closest('section[id^="shopify-section"]');
    if (!a) {
      console.warn("No current section found for variant change");
      return;
    }
    m(r, `#${a.id}`);
  },
  async handleSubmit(t) {
    if (!t.reportValidity()) return;
    const e = new FormData(t);
    if (Array.from(e.entries()).filter(c(f)).filter(([n, s]) => s === "").forEach(([n]) => e.delete(n)), e.has("items[0][properties][_bundle_parent]")) {
      const n = Array.from(e.entries()).filter(c("[id]")).map(([i, o]) => o).map(String), s = await y(n.filter((i) => i !== "" && i !== "null")), d = parseInt(e.get("items[0][quantity]")) || 1;
      n.forEach((i, o) => {
        i === "" || i === "null" ? Array.from(e.keys()).filter(h(`items[${o}]`)).forEach(e.delete.bind(e)) : (e.append(`items[${o}][properties][_bundle_id]`, s), e.has(`items[${o}][quantity]`) || e.append(`items[${o}][quantity]`, d.toString()));
      });
    }
    const r = Array.from(t.elements).find((n) => n.id.startsWith("product-notes-"));
    Array.from(e.entries()).filter(c("[quantity]")).filter(([n, s]) => s === "0").map(l("[quantity]")).forEach((n) => Array.from(e.keys()).filter(h(n)).forEach(e.delete.bind(e))), r?.value && Array.from(e.entries()).filter(c("[id]")).map(l("[id]")).map(p(r.name.match(/\[properties\]\[.+\]/)?.[0])).forEach((n) => {
      e.append(n, r.value);
    });
    const a = await fetch(t.action + ".js", {
      method: t.method,
      body: e
    });
    if (!a.ok) {
      console.error("Failed to submit form:", a.statusText);
      return;
    }
    this.$store.cart.open();
  }
}), S = () => ({
  controller: new AbortController(),
  hasQuantity: !1,
  init() {
    const t = this.$el.form;
    console.assert(t, "LockedATC must be initialized on a button in a form"), t?.addEventListener("change", () => {
      this.checkQuantity(t);
    }, { signal: this.controller.signal }), t && this.checkQuantity(t);
  },
  checkQuantity(t) {
    const e = Array.from(new FormData(t).entries()).filter(([r]) => r.endsWith("[quantity]"));
    if (e.length === 0) {
      this.hasQuantity = !0;
      return;
    }
    this.hasQuantity = e.map(([, r]) => Number(r)).some((r) => r > 0);
  },
  destroy() {
    this.controller.abort();
  }
}), f = [
  "[Send on]",
  "[Message]",
  "[selling_plan]"
], c = (t) => ([e]) => Array.isArray(t) ? t.some((r) => e.endsWith(r)) : e.endsWith(t), l = (t) => ([e]) => Array.isArray(t) ? t.reduce((r, a) => r.endsWith(a) ? r.slice(0, -a.length) : r, e) : e.endsWith(t) ? e.slice(0, -t.length) : e, p = (t = "") => (e) => e + t, h = (t) => (e) => e.startsWith(t), y = async (t) => {
  const e = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(t.toSorted().join("-")));
  return Array.from(new Uint8Array(e)).map((r) => r.toString(16).padStart(2, "0")).join("");
};
Array.prototype.toSorted ??= function(t) {
  return [...this].sort(t);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
export {
  S as LockedATC,
  w as ProductMain,
  w as default
};
